import axios from '@/api/axios';
import type {TraceLogs, Traces} from '@/types/Observability';

export const observabilityService = {
  getTraces: async (userId: string, cursor?: string): Promise<Traces> => {
    const searchParams = new URLSearchParams();
    if (cursor) {
      searchParams.append('cursor', cursor);
    }
    const response = await axios.get<Traces>(
      `/v2/admin/observability/${userId}/traces?${searchParams}`,
    );
    return response.data;
  },

  getTraceLogs: async (traceId: string): Promise<TraceLogs> => {
    const url = `/v2/admin/observability/${traceId}/logs`;
    const response = await axios.get<TraceLogs>(url);
    return response.data;
  },
};
